import { useEffect, useState } from 'react';
import useReservation from '../../hooks/useReservationData';
import Cars from './Cars';
import Summary from './Summary';
import Extras from './Extras';
import Customer from './Customer';
import Confirm from './Confirm';
import Payments from './Payments';
import useWebData from '../../hooks/useWebData';
import useConfirm from '../../hooks/useConfirm';
import { getTheCheckAdditionalCharges } from '../../utils/summaryCalculation';
import Thanks from './Thanks';
import SummaryAfterReservationConfrim from './SummaryAfterReservationConfrim';

const steps = [
  'Vehicles',
  'Extras',
  'Personal Info',
  'Confirm',
];

export const Reservation = () => {
  const { webData }: any = useWebData();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const {
    branchId,
    formattedCreatedAt,
    pickupDate,
    returnDate,
    pickupTime,
    returnTime,
    currentPage,
    setCurrentPage,
    availableVehicle,
    selectedVehicleClass,
    setSelectedVehicleClass,
    getDataFromCars,
    pickupLocationId,
    returnLocationId,
    locations,
    checkExtraValue,
    reservation,
    reservationDataFromCofirm,
    setReservationDataFromCofirm,
    securityDepositAmountToPaid,
    extraValue,
    extraValueLoaded,
    getDataFromExtras,
    getDataFromCustomer,
    localAddress,
    setLocalAddress,
    vehicleClassId,
    customerId,
    existingEmail,
    setExistingEmail,
    existingBirthday,
    setExistingBirthday,
    confirmSignatureURL,
    setConfirmSignatureURL,
    primaryKey,
    setPrimaryKey,
    customerData
  }: any = useReservation();
  const [orgainzedExtraData, setOrgainzedExtraData] = useState<any[]>([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage])

  const setTheCheckExtraValue = (updatedExtraData: any[]) => {
    getDataFromExtras(getTheCheckAdditionalCharges(updatedExtraData));
  }

  const goNext = () => {
    switch (currentPage) {
      case 1:
        if (selectedVehicleClass) {
          setCurrentPage(2);
        } else {
          setConfirmPopup(true);
          setConfirmData({
            title: `Please select a vehicle`,
            confirmBtn: "Ok",
            isConfirm: (callback: any) => {

              callback();
            }
          });
        }

        break;
      case 2:
        setTheCheckExtraValue(orgainzedExtraData)
        setCurrentPage(3)
        break;
      case 3:
        if (customerId) {
          setCurrentPage(4);
        } else {
          setConfirmPopup(true);
          setConfirmData({
            title: `Please fill the personal information`,
            confirmBtn: "Ok",
            isConfirm: (callback: any) => {

              callback();
            }
          });
        }
        break;
    }

  };

  const goBack = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };


  return (
    <div className="w-full flex flex-col md:justify-center py-8 mt-[130px]">
      {currentPage !== 5 && currentPage !== 6 && (
        <div className="w-full flex items-center justify-center gap-4 mb-8 mx-auto px-4 sm:px-6">
          {/* Back Button */}
          <button
            onClick={goBack}
            disabled={currentPage === 1}
            aria-label="Previous step"
            className={`rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ${currentPage === 1 ? 'cursor-not-allowed opacity-60' : ''
              }`}
            style={{
              backgroundColor: currentPage === 1 ? 'gray' : webData?.websiteHeaderColor
            }}
          >
            <span className="material-symbols-outlined p-2 text-white">chevron_left</span>
          </button>

          {/* Steps */}
          <div className="flex items-center justify-center flex-1 overflow-hidden">
            <div className="flex items-center gap-2 w-full justify-center">
              {steps.map((step, index) => {
                const isActive = index + 1 === currentPage;
                return (
                  <div
                    key={index}
                    // On small screens hide non-active steps, on md+ show all
                    className={`${isActive ? 'flex' : 'hidden'} md:flex items-center gap-2`}
                  >
                    {/* Step pill */}
                    <div
                      className={`flex items-center justify-center p-3 rounded-lg text-white text-sm font-semibold text-center min-w-[80px]`}
                      style={{
                        backgroundColor: index + 1 <= currentPage ? webData?.websiteHeaderColor : 'gray'
                      }}
                    >
                      {step}
                    </div>

                    {/* Connector (only md+) */}
                    {index < steps.length - 1 && (
                      <div className="hidden md:block h-1 w-6 md:w-10 bg-gray-300 mx-1">
                        <div
                          className={`h-full ${index + 1 < currentPage ? 'bg-blue-600' : ''
                            }`}
                        ></div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Next Button */}
          <button
            onClick={goNext}
            disabled={currentPage === steps.length}
            aria-label="Next step"
            className={`rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ${currentPage === steps.length ? 'cursor-not-allowed opacity-60' : ''
              }`}
            style={{
              backgroundColor: currentPage === steps.length ? 'gray' : webData?.websiteHeaderColor
            }}
          >
            <span className="material-symbols-outlined p-2 text-white">chevron_right</span>
          </button>
        </div>


      )}

      <div className="w-full p-6">
        {

          <div className='md:flex w-full md:justify-between'>
            <div className='md:w-[65%] w-full'>
              {
                currentPage === 1 && (
                  <Cars
                    availableVehicle={availableVehicle}
                    setSelectedVehicleClass={setSelectedVehicleClass}
                    selectedVehicleClass={selectedVehicleClass}
                    setCurrentPage={() => setCurrentPage(2)}
                    getDataFromCars={(vehicleClassIdString, selectedVehicleClass) =>
                      getDataFromCars(vehicleClassIdString, selectedVehicleClass)
                    }
                    reservation={reservation}
                  />
                )
              }

              {
                <div className={`${currentPage === 2 ? "block" : "hidden"}`}>
                  <Extras
                    extraValueData={extraValue}
                    getDataFromExtras={(extraValue) =>
                      getDataFromExtras(extraValue)
                    }
                    setCurrentPage={() => setCurrentPage(3)}
                    extraValueLoaded={extraValueLoaded}                   
                    orgainzedExtraData={orgainzedExtraData}
                    setOrgainzedExtraData={setOrgainzedExtraData}
                    reservation={reservation}
                  />
                </div>
              }

              {
                currentPage === 3 && (
                  <Customer
                    getDataFromCustomer={(customerId, localAddress) =>
                      getDataFromCustomer(customerId, localAddress)
                    }
                    selectedVehicleClass={selectedVehicleClass}
                    localAddress={localAddress}
                    setLocalAddress={setLocalAddress}
                    setCurrentPage={() => setCurrentPage(4)}
                    returnDate={returnDate}
                    pickupDate={pickupDate}
                    customerId={customerId}
                    existingEmail={existingEmail}
                    setExistingEmail={setExistingEmail}
                    existingBirthday={existingBirthday}
                    setExistingBirthday={setExistingBirthday}
                  />
                )
              }

              {
                currentPage === 4 && (
                  <Confirm
                    vehicleClassId={vehicleClassId}
                    branchId={branchId}
                    formattedCreatedAt={formattedCreatedAt}
                    pickupDate={pickupDate}
                    pickupTime={pickupTime}
                    returnDate={returnDate}
                    returnTime={returnTime}
                    pickupLocation={pickupLocationId}
                    returnLocation={returnLocationId}
                    locations={locations}
                    customerId={customerId}
                    localAddress={localAddress}
                    confirmSignatureURL={confirmSignatureURL}
                    setConfirmSignatureURL={setConfirmSignatureURL}
                    selectedVehicleClass={selectedVehicleClass}
                    reservation={reservation}
                    checkExtraValue={checkExtraValue}
                    securityDepositAmount={securityDepositAmountToPaid}
                    setCurrentPage={() => setCurrentPage(5)}
                    setPrimaryKey={setPrimaryKey}
                    customerData={customerData}
                    setReservation={setReservationDataFromCofirm}
                  />
                )
              }

              {
                currentPage === 5 && (
                  <Payments
                    reservation={reservationDataFromCofirm}
                    customerId={customerId}
                    setCurrentPage={() => setCurrentPage(6)}
                  />
                )
              }

              {
                currentPage === 6 && (
                  <Thanks reservation={reservationDataFromCofirm} />
                )
              }
            </div>

            {
              (currentPage !== 0) && (
                <div className='md:w-[25%] w-full'>
                  {
                    primaryKey > 0
                      ? (
                        <SummaryAfterReservationConfrim reservationData={reservationDataFromCofirm} />
                      ) : (
                        <Summary
                          currentPage={currentPage}
                          reservation={reservation}
                        />
                      )
                  }
                </div>
              )
            }
          </div>
        }
      </div>
    </div>
  );
};



